import { useCallback, useEffect, useState } from 'react';
import type { BookEventHostData } from './bookEvent.types';

export function useBookEventEagreements(data: BookEventHostData) {
  const [eagreements, setEagreements] = useState(data.eagreements);

  useEffect(() => {
    setEagreements(data.eagreements);
  }, [data.eagreements]);

  const refreshEagreements = useCallback(
    async (options?: { forceRefresh?: boolean }) => {
      const snapshot = await data.refreshEagreements(options);
      setEagreements(snapshot);
      return snapshot;
    },
    [data]
  );

  const openDocument = useCallback(
    (documentUrl: string, name?: string) => {
      setEagreements(data.openDocument(documentUrl, name));
    },
    [data]
  );

  return { eagreements, refreshEagreements, openDocument };
}
